export default __webpack_public_path__ + "static/media/agent_img.563e592e.gif";